import React from 'react';
import { Translation } from 'react-i18next';
import { cloneDeep } from 'lodash';

export default class UserDashboardDevelop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progressObj: '',
      userProgress: 0,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    let progressObj;
    const { canSeeEcap } = this.props;
    if (canSeeEcap) {
      progressObj = {
        completed_game: 15,
        paired_careers: 15,
        added_photo: 15,
        started_ecap: 15,
        completed_ecap: 5,
        searched_career: 10,
        favorited_career: 5,
        viewed_degree_details: 15,
        learned_about_riasec: 5,
      };
    } else {
      progressObj = {
        completed_game: 15,
        paired_careers: 15,
        added_photo: 15,
        searched_career: 15,
        favorited_career: 10,
        viewed_degree_details: 25,
        learned_about_riasec: 5,
      };
    }
    this.setState(
      {
        progressObj,
      },
      () => {
        this.calculateProgress();
      }
    );
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.userProgress !== this.props.userProgress) {
      this.calculateProgress();
    }
  };

  calculateProgress = () => {
    const { progressObj } = this.state;
    const { userProgress } = this.props;
    const progressCopy = cloneDeep(progressObj);
    if (userProgress) {
      Object.keys(userProgress).forEach((key) => {
        if (!userProgress[key]) {
          progressCopy[key] = 0;
        }
      });
      const result = Object.values(progressCopy).reduce((a, b) => a + b, 0);
      this.setState({
        userProgress: result,
      });
    }
  };

  render() {
    const { userProgress } = this.state;
    return (
      <Translation>
        {(t) => (
          <div className="progress-container">
            <div className="progress-row space-between">
              <span className="progress-bar-heading">
                {t('Profile Progress')}
              </span>
              <span className="progress-percentage bold progress-completed">
                {`${userProgress}%`}
              </span>
            </div>
            <div className="fillable-progress-bar">
              <div
                className="progress"
                style={{
                  backgroundColor: `${this.props.tenant.secondary}`,
                  width: `${userProgress}%`,
                }}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
